<template>
    <div class="PosterSetup spackage padding-20 bgc box-shadow">
        <div class="posterSetBox">
            <div class="title"><p>海报设置</p></div>
            <el-form :model="ruleForm" class="demo-ruleForm">
                <div class="contentBox">
                    <div class="left">
                        <el-form-item label="海报图片" required class="posterImg">
                                <div class="imgBoxPoster">
                                    <i class="el-icon-picture" v-if="!ruleForm.coveratturlidobjImg"></i>
                                    <img class="activityCoverImagePoster" :src="ruleForm.coveratturlidobjImg.furl + '?' + time" v-else-if="ruleForm.coveratturlidobjImg && ruleForm.coveratturlidobjImg.furl + '?' + time" alt="">
                                </div>
                                <div class="uploadFileBox">
                                    <UploadFile :uploadType="uploadVideoType" @setFile="setPosterFile" :fileRule="fileRule"></UploadFile>
                                    <!-- <el-button @click.native="openPosterDialog">选择文件</el-button> -->
                                    <p>建议尺寸750*1334px的JPG、PNG格式， 图片小于2M。</p>
                                </div>
                        </el-form-item>
                        <el-form-item label="邀请头像">
                                <el-switch v-model="ruleForm.isdisplayheadimg"></el-switch>
                                <el-radio-group v-model="ruleForm.headimgstyle" :disabled='!ruleForm.isdisplayheadimg'>
                                    <el-radio :label="1">圆形</el-radio>
                                    <el-radio :label="2">方形</el-radio>
                                </el-radio-group>
                        </el-form-item>
                        <el-form-item label="邀请昵称" class="inviteImg">
                                <el-switch v-model="ruleForm.isdisplaynickname"></el-switch>
                                <el-color-picker v-model="ruleForm.nicknamecolor" :disabled="!ruleForm.isdisplaynickname"></el-color-picker>
                                <el-slider :min='12' v-model="ruleForm.nicknamesize" :disabled="!ruleForm.isdisplaynickname"></el-slider>
                        </el-form-item>
                        <el-form-item label="二维码">
                                <el-switch v-model="ruleForm.isdisplayqrcode"></el-switch>
                        </el-form-item>
                    </div>

                    <div class="right">
                            <img :src="ruleForm.coveratturlidobjImg.furl + '?' + time" class="posterBg" v-if="(ruleForm.coveratturlidobjImg && ruleForm.coveratturlidobjImg.furl + '?' + time)" alt="">
                            <div @mousedown="moveHeadImg" :style="{top: ruleForm.headimgposition.split(',')[1] + 'px', left: ruleForm.headimgposition.split(',')[0] + 'px'}" :class="{'headImg': true, 'side': ruleForm.headimgstyle === 2, 'circle': ruleForm.headimgstyle === 1}" v-if="ruleForm.isdisplayheadimg">
                                头像
                            </div>
                            <div @mousedown="moveNickname" :style="{color: ruleForm.nicknamecolor ? ruleForm.nicknamecolor : '#303133', fontSize: ruleForm.nicknamesize + 'px', top: ruleForm.nicknameposition.split(',')[1]+'px', left: ruleForm.nicknameposition.split(',')[0]+'px'}" class="nickname" v-if="ruleForm.isdisplaynickname">用户昵称</div>
                            <div @mousedown="moveCode" v-show="ruleForm.isdisplayqrcode" class="rightCodeBox" :style="{top: ruleForm.qrcodeposition.split(',')[1]+'px', left: ruleForm.qrcodeposition.split(',')[0]+'px'}">
                                <div class="cover"></div>
                                <img class="serviceCode" :src="require('@/common/images/toolmgt/code.png')" alt="">
                            </div>
                            <!-- <img @mousedown="moveCode" class="serviceCode" v-if="ruleForm.isdisplayqrcode && ruleForm.qrcodeatturlid" :style="{top: ruleForm.qrcodeposition.split(',')[1]+'px', left: ruleForm.qrcodeposition.split(',')[0]+'px'}" :src="ruleForm.qrcodeatturlid.furl+'?'+time" alt=""> -->
                    </div>
                </div>
            </el-form>
            <div>
                <el-button @click="back">取消</el-button>
                <el-button type="primary" @click="submit">确定</el-button>
            </div>
        </div>
    </div>
</template>

<script>
import UploadFile from 'base/upload/uploadFile2'
import {getAssEventPosterInfo, saveOrUpdateAssEventPoster} from 'api/taskToolsApi'
import {computeFileSize} from 'common/js/tools'
import { mapActions} from 'vuex' // 引入 vuex 组件
export default {
    name: 'PosterSetup',
    data() {
        return {
            innerid: this.$route.query.innerid,
            eventinnerid: this.$route.query.eventinnerid,
            time: new Date().getTime(),
            ruleForm: {
                posterinnerid: '', // 海报信息ID
                coveratturlidobj	: '', // 海报LOGO图(JSON串)
                coveratturlidobjImg: '',
                isdisplayheadimg: true, // 是否显示头像
                headimgstyle: 1, // 头像样式——1圆形 2方形
                headimgposition: '22,22', // 头像位置——格式X,Y
                isdisplaynickname: true, // 是否显示昵称
                nicknamecolor: '#000000', // 昵称字体颜色，带#
                nicknamesize: 12, // 昵称字体大小
                nicknameposition: '98,38', // 昵称位置——格式X,Y
                isdisplayqrcode: true, // 是否显示二维码
                qrcodeposition: '190,420', // 二维码位置——格式X,Y,
            },
            uploadVideoType: {
                catecode: '95',
                datatype: 'IMAGE'
            },
            fileRule: {
                btnName: '选择文件',
                cls: '',
                accept: '.jpg,.jpeg,.png',
                size: 2,
                width: '750',
                height: '420'
            },
        }
    },
    mounted() {
        if (this.innerid) {
            this.posterDetails()
        }
    },
    methods: {
        // 海报详情
        posterDetails() {
            this.setLoading(true)
             getAssEventPosterInfo({
                data: {eventinnerid: this.eventinnerid, innerid: this.innerid},
                success: data => {
                    data.data.coveratturlidobjImg = data.data.coveratturlidobj

                    this.ruleForm = data.data
                    // this.ruleForm.coveratturlidobjImg = this.ruleForm.coveratturlidobj
                    this.justSwitchBoolear(['isdisplaynickname', 'isdisplayqrcode', 'isdisplayheadimg'], 2, this.ruleForm)
                    this.ruleForm.nicknamesize = Number(this.ruleForm.nicknamesize)

                    // console.log('ruleForm', this.ruleForm)

                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
         // 移动头像
        moveHeadImg(e) {
            let odiv = e.target       //获取目标元素
            //算出鼠标相对元素的位置
            let disX = e.clientX - odiv.offsetLeft
            let disY = e.clientY - odiv.offsetTop
            document.onmousemove = (e)=>{       //鼠标按下并移动的事件
                //用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
                let left = e.clientX - disX
                let top = e.clientY - disY
                //移动当前元素
                if (left >= 0 && left < 250) {
                    odiv.style.left = left + 'px'
                    this.ruleForm.headimgposition = left + ',' + this.ruleForm.headimgposition.split(',')[1]
                }
                if (top >= 0 && top < 484) {
                    odiv.style.top = top + 'px'
                    this.ruleForm.headimgposition = this.ruleForm.headimgposition.split(',')[0] + ',' + top
                }
            }
            document.onmouseup = (e) => {
                document.onmousemove = null
                document.onmouseup = null
            }
        },
        // 移动昵称
        moveNickname(e) {
            let odiv = e.target       //获取目标元素
            //算出鼠标相对元素的位置
            let disX = e.clientX - odiv.offsetLeft
            let disY = e.clientY - odiv.offsetTop
            document.onmousemove = (e)=>{       //鼠标按下并移动的事件
                //用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
                let left = e.clientX - disX
                let top = e.clientY - disY
                //移动当前元素
                if (left >= 0 && left < 248) {
                    odiv.style.left = left + 'px'
                    this.ruleForm.nicknameposition = left + ',' + this.ruleForm.nicknameposition.split(',')[1]
                }
                if (top >= 0 && top < 520) {
                    odiv.style.top = top + 'px'
                    this.ruleForm.nicknameposition = this.ruleForm.nicknameposition.split(',')[0] + ',' + top
                }
            }
            document.onmouseup = (e) => {
                document.onmousemove = null
                document.onmouseup = null
            }
        },
        // 移动二维码
        moveCode(e) {
            let odiv = e.target.parentElement       //获取目标元素
            //算出鼠标相对元素的位置
            let disX = e.clientX - odiv.offsetLeft
            let disY = e.clientY - odiv.offsetTop
            document.onmousemove = (e)=>{       //鼠标按下并移动的事件
                //用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
                let left = e.clientX - disX
                let top = e.clientY - disY
                //移动当前元素
                if (left >= 0 && left < 219) {
                    odiv.style.left = left + 'px'
                    this.ruleForm.qrcodeposition = left + ',' + this.ruleForm.qrcodeposition.split(',')[1]
                }
                if (top >= 0 && top < 454) {
                    odiv.style.top = top + 'px'
                    this.ruleForm.qrcodeposition = this.ruleForm.qrcodeposition.split(',')[0] + ',' + top
                }
            }
            document.onmouseup = (e) => {
                document.onmousemove = null
                document.onmouseup = null
            }
        },
        setPosterFile(file) {
            computeFileSize()
            this.ruleForm.coveratturlidobj = file
            this.ruleForm.coveratturlidobjImg = file
            this.time = new Date().getTime()
        },
        submit() {
            let formData = JSON.parse(JSON.stringify(this.ruleForm))
            this.imgJson(['coveratturlidobjImg','coveratturlidobj'],1,formData)
            // bolear 与 0 1 转换
            this.justSwitchBoolear(['isdisplaynickname', 'isdisplayqrcode', 'isdisplayheadimg'], 1, formData)

            formData.eventinnerid = this.eventinnerid
            formData.headimgstyle = parseInt(formData.headimgstyle)

            if (! this.innerid) {
                // 修改
                formData.innerid = this.innerid
            }
            this.setLoading(true)
            saveOrUpdateAssEventPoster({
                data: formData,
                success: data => {
                    this.$message.success('操作成功')
                    this.back()
                    this.setLoading(false)
                },
                error: data => {
                    this.$message.error(data.msg)
                    this.setLoading(false)
                }
            })
        },
         // boolear 进行  true false 与 1 0 转换
        justSwitchBoolear (array, type, data) {
            let form = []
            
            if (data) {
                form = data
            }
           for (let item in form) {
            //    console.log(item)
                for (let i = 0; i < array.length; i++) {

                    if (item === array[i]) {
                         // 判断类型 数字和布尔互转
                        if (type === 1) {
                            form[item] = form[item] === true ? 1 : 0
                        } else {
                            form[item] = form[item] === 1 ? true : false
                        }
                    }
                   
                }
           }

        },
        back() {
            this.$router.go(-1)
        },
        imgJson(array, type, data) {
            if (type == 1) {
                for (let item in data) {
                    for (let i = 0; i < array.length; i++) {
                        if (item === array[i]) {
                            if (data[item].furl)  {
                                delete data[item].type
                                data[item] = JSON.stringify(data[item])
                            }
                        }
                    }
                }
            }
        },
        ...mapActions(['setLoading'])
        
    },
    components: {
        UploadFile,
    }
}
</script>

<style lang="scss" type="text/scss">
.PosterSetup {
    .title {
        padding: 20px 0;
        padding-top: 0;
        border-bottom: solid 1px #DCDFE6;
        p { 
            border-left: solid #409EFF 2px;
            padding-left: 10px;
            font-size: 16px;
            font-weight: bold;
        }
    }
    .posterSetBox{
            background: #fff;
            padding: 20px;
            margin-bottom: 24px;
            .contentBox{
                padding-top: 20px;
                display: flex;
                // justify-content: space-between;
                .left{
                    .cover,.posterImg{
                        .el-form-item__content{
                            display: flex;
                            align-items: center;
                            .imgBox{
                                width: 318px;
                                height: 178px;
                                background: #F5F7FA;
                                text-align: center;
                                line-height: 178px;
                                .el-icon-picture{
                                    color: #DCDFE6;
                                    font-size: 40px;
                                }
                                .activityCoverImage{
                                    width: 318px;
                                    height: 178px;
                                }
                            }
                            .uploadFileBox{
                                margin-left: 12px;
                                .uploadFile{
                                    .upload-demo{
                                        .el-upload {
                                            .el-button{
                                                background: #fff;
                                                color: #000;
                                                border: 1px solid #C0C4CC;
                                            }
                                        }
                                    }
                                }
                                p{
                                    width: 200px;
                                    color: #909399;
                                    font-size: 14px;
                                    line-height: 20px;
                                }
                            }
                        }
                    }
                    .el-form-item{
                        .el-form-item__content{
                            .el-input{
                                width: 400px;
                            }
                            .el-date-editor{
                                .el-input__icon, .el-range-separator{
                                    line-height: 25px;
                                }
                            }
                            .mostTips{
                                color: #C0C4CC;
                            }
                            .showRankingListTips{
                                color: #909399;
                                margin-left: 20px;
                                position: relative;
                                top: 2px;
                            }
                        }
                    }
                    .date{
                        .el-form-item__label::after{
                            content: '*';
                            color: #F56C6C;
                            margin-left: 4px;
                        }
                        .el-form-item__content{
                            width: 500px;
                            .to{
                                margin: 0 13px;
                            }
                            .el-date-editor {
                                width: 180px;
                                .el-input__inner{
                                    padding-right: 0;
                                }
                            }
                        }
                    }
                }
                .right{
                    width: 300px;
                    height: 534px;
                    background:rgba(242,246,252,1);
                    box-shadow:0px 0px 8px 0px rgba(0,0,0,0.3);
                    overflow: hidden;
                    margin-left: 150px;
                    .innerBox{
                        width: 320px;
                        height: 482px;
                        overflow-y: scroll;
                    }
                    .topBox{
                        height: 52px;
                        .top{
                            width: 300px;
                            height: 52px;
                        }
                    }
                    .coverImgBox{
                        background: #DCDCDC;
                        width: 300px;
                        height: 168px;
                        .activityCoverImage{
                            width: 300px;
                            height: 168px;
                        }
                    }
                    .priceBox{
                        height: 60px;
                        background: #fff;
                        border-bottom: 1px solid #f5f5f5;
                        padding: 7px 12px;
                        box-sizing: border-box;
                        .price{
                            color: #F56C6C;
                            margin-top: 5px;
                        }
                        .outofprint{
                            color: #909399;
                            margin-top: 10px;
                        }
                    }
                    .rightTitleBox{
                        height: 60px;
                        background: #fff;
                        padding: 7px 12px;
                        box-sizing: border-box;
                        .rightTitle{
                            margin-top: 5px;
                        }
                        .rightSubtitle{
                            color: #909399;
                            margin-top: 10px;
                        }
                    }
                    .detailsBox{
                        margin-top: 10px;
                        .detailsTitle{
                            background: #fff;
                            padding-left: 12px;
                            height: 40px;
                            line-height: 40px;
                            border-bottom: 1px solid #f5f5f5;
                        }
                        .detailsContent{
                            background: #fff;
                            padding: 12px;
                            p{
                                line-height: 15px;
                            }
                            img{
                                width: 100%;
                            }
                        }
                    }
                }
            }
    }
    .posterSetBox{
            background: #fff;
            .contentBox{
                .left{
                    width: 701px;
                    .el-form-item{
                        .el-switch{
                            margin-right: 30px; 
                        }
                    }
                    .imgBoxPoster{
                        width: 178px;
                        height: 317px;
                        background: #F5F7FA;
                        text-align: center;
                        line-height: 317px;
                        .el-icon-picture{
                            color: #DCDFE6;
                            font-size: 40px;
                        }
                        .activityCoverImagePoster{
                            width: 178px;
                            height: 317px;
                        }
                    }
                    .inviteImg{
                        .el-form-item__content{
                            display: flex;
                            align-items: center;
                            .el-color-picker {
                                width: 16px;
                                height: 16px;
                                margin-right: 28px;
                                .el-color-picker__trigger{
                                    padding: 0;
                                    width: 16px;
                                    height: 16px;
                                }
                            }
                            .el-slider{
                                width: 160px;
                                display: inline-block;
                            }
                        }
                    }
                    .serviceSet{
                        .title{
                            border-bottom: none;
                        }
                        .imgBoxCode{
                            width: 178px;
                            background: #F5F7FA;
                            text-align: center;
                            line-height: 178px;
                            height: 178px;
                            .el-icon-picture{
                                color: #DCDFE6;
                                font-size: 40px;
                            }
                            .activityCoverImage{
                                width: 178px;
                                height: 178px;
                            }
                        }
                    }
                }
                .right{
                    margin-left: 0;                    
                    position: relative;
                    .posterBg{
                        width: 300px;
                        height: 534px;
                    }
                    .headImg{
                        width: 48px;
                        height: 48px;
                        background: #D8D8D8;
                        border: 1px solid #979797;
                        text-align: center;
                        line-height: 48px;
                        position: absolute;
                        cursor: move;
                    }
                    .side{
                        border-radius: 0;
                    }
                    .circle{
                        border-radius: 50%;
                    }
                    .nickname{
                        position: absolute;
                        cursor: move;
                    }
                    .rightCodeBox{
                        cursor: move;
                        position: absolute;
                        .cover{
                            width: 80px;
                            height: 80px;
                            position: absolute;
                        }
                        img{
                            width: 80px;
                            height: 80px;
                        }
                    }
                }
            }
        }
}
</style>